import React, { useMemo, useState } from 'react';

import { Autocomplete } from '@flixbus/honeycomb-react';

const sanitizeDigits = (value) => String(value ?? '').replace(/\D+/g, '');

const TripNumbers = ({
	value = [],
	onSelection = () => {},
	onReset = () => {},
	onSingleItemReset = () => {},
	extraClasses = '',
}) => {
	const [inputValue, setInputValue] = useState('');

	const selectedOptions = useMemo(() => {
		return value.map((item) => ({
			title: String(item),
			value: String(item),
		}));
	}, [value]);

	const buildFakeOptions = (typedValue) => {
		if (!typedValue) return [];

		return [
			{
				title: typedValue,
				value: typedValue,
				subtitle: 'Select to add',
			},
		];
	};

	const handleInputChange = (event) => {
		const rawValue = event?.target?.value ?? '';
		const nextValue = sanitizeDigits(rawValue);
		setInputValue(nextValue);
	};

	const handleDebounce = (typedValue) => {
		return buildFakeOptions(sanitizeDigits(typedValue));
	};

	const handleAutocompleteChange = (selectedOptions) => {
		const nextSelected = Array.isArray(selectedOptions) ? selectedOptions : [];
		const previousSelectedValues = value.map((item) => String(item));
		const nextSelectedValues = nextSelected
			.map((item) => sanitizeDigits(item.value))
			.filter((item) => item.length > 0);

		if (nextSelectedValues.length > previousSelectedValues.length) {
			const addedValue = nextSelectedValues.find((item) => !previousSelectedValues.includes(item));

			if (addedValue !== undefined) {
				onSelection(addedValue);
				setInputValue('');
			}

			return;
		}

		if (nextSelectedValues.length < previousSelectedValues.length) {
			if (nextSelectedValues.length === 0) {
				onReset();
				return;
			}

			const removedValue = previousSelectedValues.find(
				(item) => !nextSelectedValues.includes(item)
			);

			if (removedValue !== undefined) {
				onSingleItemReset(removedValue);
			}
		}
	};

	return (
		<Autocomplete
			extraClasses={extraClasses}
			multiple
			value={selectedOptions}
			inputValue={inputValue}
			options={buildFakeOptions(inputValue)}
			debounce={300}
			onDebounce={handleDebounce}
			onChange={handleAutocompleteChange}
			comboboxProps={{
				label: 'Trip number',
				placeholder: 'E.g. 1001, 1002',
				limitSelectedOptions: 3,
				inputMode: 'numeric',
				onChange: handleInputChange,
				tagProps: (selectedOption) => ({
					closeProps: {
						label: `Remove ${selectedOption.title}`,
					},
				}),
			}}
			listBoxProps={{
				label: 'Trip numbers',
				optionsToDisplay: 5,
			}}
		/>
	);
};

export default TripNumbers;
